import { queryClient } from "@impero-com/common/utils/query_client";

import { useDeleteTestingControls } from "../../../../../api/generated/testing-controls/testing-controls";

import { TESTING_CONTROLS_QUERY_KEY } from "./useTestingProgramTestingControlsQuery";

export function useBulkDeleteTestingControlMutation() {
    return useDeleteTestingControls({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: [TESTING_CONTROLS_QUERY_KEY],
                });
            },
        },
    });
}
